import React from 'react'
import { Tooltip, Typography, Button, Box } from '@mui/material'
import { styled } from '@mui/material/styles'

// destructure to not pass custom props to Dialog DOM element
// eslint-disable-next-line @typescript-eslint/no-unused-vars

const HtmlTooltip = styled(Tooltip)`
  img {
    cursor: pointer;
  }
  @media (max-width: 900px) {
    img {
      width: 18px;
    }
  }
`

const TooltipButton = styled(Button)`
  padding: 0;
  min-width: inherit;
  text-transform: inherit;
  :hover {
    background: transparent;
  }
`

const TitleTypography = styled(Typography)`
  color: rgb(255, 255, 255);
  font-size: 1.25rem;
  line-height: 1.75rem;
  letter-spacing: 0.02em;
  font-weight: bold;
  margin-bottom: 2px;
`

interface CommonTooltipProps {
  title?: string
  width?: number | string
  content: string | JSX.Element
  open?: boolean
  placement?:
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start'
    | 'top'
  children: JSX.Element
  confirmText?: string
  closeText?: string
  onClose?: () => void
  onConfirm?: () => void
}

export default function CommonTooltip({
  title,
  placement = 'bottom',
  confirmText = 'Got It',
  closeText = 'Learn more',
  content,
  open,
  children,
  width = 300,
  onClose,
  onConfirm,
}: CommonTooltipProps) {
  return (
    <>
      <HtmlTooltip
        arrow
        placement={placement}
        open={open}
        title={
          <React.Fragment>
            {title && <TitleTypography>{title}</TitleTypography>}
            <Typography variant="body1" component="div" width={width}>
              {content}
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              {onClose && (
                <TooltipButton
                  onClick={onClose}
                  sx={{
                    color: 'rgba(0, 255, 10, 0.8)',
                  }}
                >
                  {closeText}
                </TooltipButton>
              )}
              {onConfirm && (
                <TooltipButton
                  onClick={onConfirm}
                  sx={{
                    marginLeft: '24px',
                  }}
                >
                  {confirmText}
                </TooltipButton>
              )}
            </Box>
          </React.Fragment>
        }
      >
        {children}
      </HtmlTooltip>
    </>
  )
}
